import React, { useState } from "react";
import "~/assets/sass/pages/round/external/external.scss";
import "~/assets/sass/pages/round/common/applicantList.scss";
import logoImg from "~/assets/img/logo-black.svg";
import useAlert from "~/common/hooks/useAlert";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import CompanyModal from "./CompanyModal";
import EvaluateSection from "./EvaluateSection";
import { dateToString } from "~/utils/formatter";

const InfoModal = ({ status, applyResultModal, setApplyResultModal, userNm, detail, handleGo }) => {
	const [companyDetailModal, setCompanyDetailModal] = useState();
	const [showConfirmAlert, ConfirmAlert] = useAlert();

	const titleList = [
		<div className="applicant-detail-header">
			<span className="title">참여기업</span> <span>{detail?.info?.roundName}</span>
		</div>,
	];

	return (
		<>
			<ModalTemplate
				modalState={applyResultModal}
				setModalToggle={setApplyResultModal}
				title={titleList}
				width={1470}
				height={930}
				className="apply-result-modal evaluate-result-wrap"
			>
				<div className="modal-content">
					<div className="applicant-detail-body">
						<div className="applicant-info">
							<div className="company-info-wrap">
								<div className="img-wrap">
									<img src={detail?.info?.logoSqu || logoImg} alt="회사로고" />
								</div>
								<div className="company-info">
									<h4 className="company-name">{detail?.info?.companyName}</h4>
									<span className="company-abst">
										{detail?.info?.address
											? detail?.info?.address.substring(0, 2)
											: "-"}{" "}
										/{" "}
										{new Date().getFullYear() -
											parseInt(detail?.company?.estDate?.substring(0, 4))}
										년{" "}
										{new Date().getMonth() -
											parseInt(detail?.company?.estDate?.substring(5, 7))}
										개월 / {detail?.company?.bizType}
									</span>
								</div>
							</div>
							<button
								className="btn__outline angled"
								color="primary"
								onClick={() => setCompanyDetailModal(true)}
							>
								기업정보
							</button>
						</div>
						<section>
							<h3 className="section-title">이용약관 동의</h3>
							<div className="c__form">
								<div className="f__group">
									<div className="f__label">개인정보수집 및 이용 동의서</div>
									<div className="f__control">
										{detail?.shared ? "동의" : "미동의"}
									</div>
								</div>
							</div>
						</section>
						<section>
							<h3 className="section-title">참여기업 정보</h3>
							<div className="c__form">
								{detail?.answer &&
									detail.answer.length > 0 &&
									detail.answer.map((inquiry, index) => {
										switch (inquiry.type) {
											case "CATEGORY":
												return (
													<h3 className="section-title" key={index}>
														{(inquiry.title !== "none") ? inquiry.title : "" }
													</h3>
												);
											case "AGREE":
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}
														</div>
														<div className="f__control">
															{inquiry.answer ? "동의" : "비동의"}
														</div>
													</div>
												);
											case "TEXT":
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															* {inquiry.title}
														</div>
													</div>
												);
											case "TAG":
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}
														</div>
														<div className="f__control">
															{inquiry.answer &&
															inquiry.answer?.length > 0
																? inquiry.answer.join(", ")
																: "-"}
														</div>
													</div>
												);
											case "FILE":
												const answer = { name: "", url: "" };
												if (
													inquiry?.answer &&
													inquiry?.answer.search("name") > 0
												) {
													let answerObject = JSON.parse(inquiry.answer);
													answer.name = answerObject.name;
													answer.url = answerObject.url;
												} else {
													answer.name = "_" + inquiry.title;
													answer.url = inquiry.url;
												}

												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}(첨부파일)
														</div>
														<div className="f__control">
															<a href={answer.url}>{answer?.name}</a>
														</div>
													</div>
												);
											case "TITLE":
												return null;
											case "LINK":
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}(파일링크)
														</div>
														<div className="f__control">
															<a href={inquiry.answer}>
																{inquiry.answer}
															</a>
														</div>
													</div>
												);
											case "DATE":
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}
														</div>
														<div className="f__control">
															{inquiry.answer
																? dateToString(
																		inquiry.answer,
																		"yyyy-MM-dd"
																  )
																: "-"}
															{}
														</div>
													</div>
												);
											case "MULTISELECT":
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}
														</div>
														<div className="f__control">
															{inquiry.answer &&
																inquiry.answer
																	.map((item) => item.label)
																	.join(",")}
														</div>
													</div>
												);
											default:
												return (
													<div className="f__group" key={index}>
														<div className="f__label">
															{inquiry.title}
														</div>
														<div className="f__control">
															{inquiry.answer}
														</div>
													</div>
												);
										}
									})}
							</div>
						</section>
					</div>
					<EvaluateSection
						showConfirmAlert={showConfirmAlert}
						evalDetailData={detail}
						setApplyResultModal={setApplyResultModal}
						viewtype={status === "심사중" || status === "지원마감"}
						userNm={userNm}
					/>
				</div>
			</ModalTemplate>
			<CompanyModal {...{ companyDetailModal, setCompanyDetailModal, detail }} />
			<ConfirmAlert message="심사가 완료되었습니다." type="success" confirm="확인" />
		</>
	);
};

export default InfoModal;
